import React from 'react'
import logo from './logo.svg'
import './App.css'
import characterMain from './icons/character-main.png'
import characterCode from './icons/character-coding.png'
import characterDesign from './icons/character-design.png'
import characterCloud from './icons/character-cloud.png'
import characterTravel from './icons/character-travel.png'
;


export default function 
() {

  return (
   
    <swiper-container className="mySwiper" effect="cards" pagination="true" pagination-type="fraction" grab-cursor="true" loop="true" autoplay-delay="2000">
    <swiper-slide><img src={characterMain} alt="" className='icons-character'/></swiper-slide>
    <swiper-slide><img src={characterCode} alt="" className='icons-character'/></swiper-slide>
    <swiper-slide><img src={characterDesign} alt="" className='icons-character'/></swiper-slide>
    <swiper-slide><img src={characterCloud} alt="" className='icons-character'/></swiper-slide>
    <swiper-slide><img src={characterTravel} alt="" className='icons-character'/></swiper-slide>
    {/* <swiper-slide>Slide 6</swiper-slide> */}
  </swiper-container>
    

  )
}
